module.exports = __webpack_public_path__ + "img/ss4.1c777591.jpg";